import { connect } from 'react-redux';
import DividendDetails, {
  DividendProps,
} from '@/components/DeprecatedPortfolio/components/Dividend';
import { holdingsByDividendSelector } from '@/components/DeprecatedPortfolio/components/Dividend/redux/selectors';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import { get } from 'lodash';

type StateProps = Pick<
  DividendProps,
  | 'currentDividend'
  | 'totalValue'
  | 'currencyISO'
  | 'isWatchlist'
  | 'dividendHoldings'
>;
const mapStateToProps = (state): StateProps => {
  const portfolio = portfolioSelector(state);
  return {
    currentDividend: get(portfolio, 'currentDividend'),
    totalValue: get(portfolio, 'totalValue', 0),
    currencyISO: get(portfolio, 'currencyISO', 'USD'),
    isWatchlist: get(portfolio, 'isWatchlist', false),
    dividendHoldings: holdingsByDividendSelector(state),
  };
};

export default connect<StateProps, unknown, Partial<DividendProps>>(
  mapStateToProps
)(DividendDetails);
